import React, { Fragment } from 'react';
import { GoogleMap, InfoWindow, Marker } from 'react-google-maps';
import PropTypes from 'prop-types';
import List from './List';
import Legend from './Legend';
import { icon, invalidColor, validColor, noDataColor } from '../../utils/styleConst';
import { getAvailablesPlaces, isParamActive } from '../../service/availablesPlacesData';


const GoogleMapComponent = ({
  isMarkerShown, onToggleOpen, openInfoWindowMarkerId, studioData, zoomToMarkers,
}) => (
  <Fragment>

    <GoogleMap
      ref={zoomToMarkers && zoomToMarkers}
      defaultCenter={{ lat: 48.8534, lng: 2.3488 }}
      defaultZoom={6}
    >
      {isMarkerShown &&
        studioData.map((studio, index) => {
          let color;

          if (getAvailablesPlaces(studio) > 0) {
              color = validColor;
          } else {
              color = invalidColor;
          }

          if (studio.liveAvailablePlaces === -1 &&
            isParamActive('availablesPlaces') &&
            !isParamActive('remainingSubscriptions')) {
              color = noDataColor;
          }

          return (
            <Marker
              key={index}
              position={{ lat: Number(studio.latitude), lng: Number(studio.longitude) }}
              icon={icon(color)}
              onClick={onToggleOpen(index)}
            >
              {openInfoWindowMarkerId === index &&
                <InfoWindow key={index} onCloseClick={onToggleOpen(index)}>
                  <List studio={studio} />
                </InfoWindow>
              }
            </Marker>
          );
        })
    }
    </GoogleMap>
    <Legend studioData={studioData} />
  </Fragment>
);
GoogleMapComponent.defaultProps = {
  openInfoWindowMarkerId: null,
  zoomToMarkers: undefined,
};

GoogleMapComponent.propTypes = {
  isMarkerShown: PropTypes.bool.isRequired,
  onToggleOpen: PropTypes.func.isRequired,
  zoomToMarkers: PropTypes.func,
  openInfoWindowMarkerId: PropTypes.number,
  studioData: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default GoogleMapComponent;




// WEBPACK FOOTER //
// src/components/googleMap/GoogleMapComponent.jsx